module.exports = __webpack_public_path__ + "img/logo_edu_match.67847c10.png";